// extracted by mini-css-extract-plugin
export default {"StickyButton":"StickyButton_StickyButton__qKig9"};